// #region Imports

import * as $ from 'jquery';
import * as Mark from 'mark.js';

// #endregion Imports

// #region Exports

export function initialize(): void {
    marker = new Mark('.xml_content');
    currentValue = $('.document-search__input').val() as string;
    wireEvents();

    if (currentValue) {
        queueHighlightUpdate();
    }
}

(window as any).unmark = unmark;

// #endregion Exports

// #region Private functions

let currentValue: string;
let currentIndex: number;
let highlights: JQuery<Node>;
let marker: Mark;
let numberOfHighlights: number;
let timeout: NodeJS.Timer;

function wireEvents(): void {
    $('.document-search__input').on('propertychange keyup input paste', onInputChange);
    $('.document-search__next').on('click', onNextClick);
    $('.document-search__next').keyup(function (event) {
        if (event.keyCode === 13) {
            $('.document-search__next').click();
        }
    });
    $('.document-search__previous').on('click', onPreviousClick);
    $('.document-search__previous').keyup(function (event) {
        if (event.keyCode === 13) {
            $('.document-search__previous').click();
        }
    });
    $('#document-tool-trigger').on('click', onToggleDocumentTools);
}

function unmark(): void {
    marker.unmark();
}

function onToggleDocumentTools() {
    const $this = $(this);
    const openClassName = 'mobile-toolbar__options--open';
    
    if($this.hasClass(openClassName)) {
        $this.removeClass(openClassName);
        $('.document-toolbar').removeClass('document-toolbar--open');
    }
    else {
        $this.addClass(openClassName);
        $('.document-toolbar').addClass('document-toolbar--open');
    }
}

function onInputChange(e: any): void {
    const value = $(this).val() as string;

    if (value === currentValue) {
        return;
    }

    currentValue = value;
    queueHighlightUpdate();
}

function onNextClick(e: any) {
    e.preventDefault();

    currentIndex++;
    if (currentIndex >= numberOfHighlights) {
        currentIndex = numberOfHighlights - 1;
    }

    focusHighlight();
}

function onPreviousClick(e: any) {
    e.preventDefault();

    if (currentIndex > 0) {
        currentIndex--;
    } else {
        currentIndex = 0;
    }

    focusHighlight();
}

function focusHighlight() {
    const examModeContainer = document.getElementById("exam-mode-container");
    const $target = $(highlights[currentIndex] as any);
    let position = $target.offset().top - $(".header").outerHeight() - $('#documentHeader').outerHeight();
    position = examModeContainer ? position - $("#exam-mode-container").outerHeight() : position;

    $('.highlight--active').removeClass('highlight--active');
    $target.addClass('highlight--active');

    lockToolbar();
    $("html, body").animate({ scrollTop: position }, 500, unlockToolbar);
    updateNavigationInformation();
}

function lockToolbar() {
    $('.document-toolbar').addClass('js-locked');
}

function unlockToolbar() {
    $('.document-toolbar').removeClass('js-locked');
}

function queueHighlightUpdate() {
    clearTimeout(timeout);

    timeout = setTimeout(updateHighlight, 500);
}

function updateHighlight() {
    marker.unmark();

    if (!currentValue || currentValue.length < 2) {
        hideNavigation();
        hideNavigationZeroHits();
        return;
    }

    marker.mark(currentValue, { element: 'x-marker', className: 'highlight', separateWordSearch: false, diacritics: false });

    updateNavigation();
}

function updateNavigation() {
    highlights = $('.highlight');
    numberOfHighlights = highlights.length;

    currentIndex = -1;
    updateNavigationInformation();

    if (numberOfHighlights === 0) {
        hideNavigation();
        showNavigationZeroHits();
        return;
    }

    showNavigation();
}

function updateNavigationInformation() {
    $('.document-search__hits').text(`${currentIndex + 1} av ${numberOfHighlights}`);
}

function hideNavigation() {
    $('.document-search__navigation').addClass('document-search__navigation--hidden').addClass('document-search__navigation__zero-hits');
    $('.document-search__icon').removeClass('document-search__icon--has-result');
}

function hideNavigationZeroHits() {
    $('.document-search__navigation').removeClass('document-search__navigation__zero-hits');
}

function showNavigationZeroHits() {
    $('.document-search__icon').addClass('document-search__icon--has-result');
}

function showNavigation() {
    $('.document-search__navigation').removeClass('document-search__navigation--hidden').removeClass('document-search__navigation__zero-hits');
    $('.document-search__icon').addClass('document-search__icon--has-result');
}

// #endregion Private functions